<template>
    <div class="statistics">
        <div class="statistics_block" v-clickOutside="() => closeStatistic()">
            <div class="statistics_header">
                <div class="title">
                    {{title}}
                </div>
                <div class="svg" @click="closeStatistic()">
                    <svg width="24" height="24" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14.3751 4.1665L9.99951 8.5415L5.62489 4.1665L4.16669 5.62484L8.5413 9.99984L4.16669 14.3748L5.62489 15.8332L9.99951 11.4582L14.3751 15.8332L15.8334 14.3748L11.4587 9.99984L15.8334 5.62484L14.3751 4.1665Z" fill="#ABABB2"/>
                    </svg>
                </div>
            </div>
            <div class="statistics_main_info">
                <div class="statistics_main_info_block_all">
                    <div class="setting_groups_student_header">
                        <div class="wallet_main_header_left" >
                            <div class="select_student" 
                                v-for="(item, i) in typeStudent"
                                :key="i"
                                :class="(typeStudentId === i)?('select_student_active'):('select_student')" 
                                @click="selectStudentFuncHeader(item)"
                            >
                                {{item.text}} 
                            </div>
                            
                        </div>
                    </div>
                    <div class="statistics_main_info_block" v-if="typeStudentId === 0">
                        <div :class="(header1.length === 5)?'statistics_main_info_block_header_change_payment' : 'statistics_main_info_block_header_change_payment_lengh_3'">
                            <div v-for="(item, i) in header1" :key="i">
                                {{item.text}}
                            </div>
                        </div>
                        <div  v-for="(item, i) in arrList1" 
                                :key="i"
                                :class="(header1.length === 5)?'statistics_main_info_block_change_payment':'statistics_main_info_block_change_payment_lengh_3'"
                                :style="arr1.length-1 === i ? 'border-bottom: 0px solid black' : ''"
                        >
                            <div class="sourse" >
                                {{item.cause}}
                            </div>
                            <div class="month" v-if="header1.length === 5">
                                {{item.month}}
                            </div>
                            <div class="date">
                                {{item.discount}}
                            </div>
                            <div v-if="header1.length === 5">
                                {{item.time_str}}
                            </div>
                            <div :class="(item.change.slice(0, 1) === '-')?'change_minus' : ('change')">
                                {{item.amount}}
                            </div>
                        </div>
                    </div>
                    <div class="statistics_main_info_block"  v-else-if="typeStudentId === 1">
                        <div class="statistics_main_info_block_header">
                            <div v-for="(item, i) in header" :key="i">
                                {{item.text}}
                            </div>
                        </div>
                        <div  v-for="(item, i) in arrList" 
                                :key="i"
                                class="statistics_main_info_block_list"
                                :style="arr.length-1 === i ? 'border-bottom: 0px solid black' : ''"
                        >
                            <div class="sourse" >
                                {{item.name}}
                            </div>
                            <div class="manager">
                                {{item.manager}}
                            </div>
                            <div class="date">
                                {{item.time_str}}
                            </div>
                            <div class="new_amount">
                                {{item.new_amount}}
                            </div>
                            <div :class="item.change_amount < 0 ? 'change_minus' : 'change'">
                                {{item.change_amount > 0 ? "+" + item.change_amount : item.change_amount}}
                            </div>
                            <div class="svg">
                                <div class="svg_block">
                                    <div class="svg_block_active"  v-if="item.comment !== null" @mouseenter="item.showModule = true" @mouseleave="item.showModule = false">
                                        <div class="svg_block_active_svg">
                                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M14.3 2.75H7.7C4.97007 2.75 2.75 5.08692 2.75 7.96053V18.3816C2.75 18.8609 3.1196 19.25 3.575 19.25H14.3C17.0299 19.25 19.25 16.9131 19.25 14.0395V7.96053C19.25 5.08692 17.0299 2.75 14.3 2.75ZM17.6 14.0395C17.6 15.9552 16.12 17.5132 14.3 17.5132H4.4V7.96053C4.4 6.04479 5.88005 4.48684 7.7 4.48684H14.3C16.12 4.48684 17.6 6.04479 17.6 7.96053V14.0395Z" fill="#C0CADC"/>
                                            </svg>    
                                        </div>
                                        <transition name="fade">
                                            <div class="svg_module" v-show="item.showModule === true">
                                                {{item.comment}}
                                            </div>
                                        </transition>
                                    </div>
                                    <div v-else class="svg_text">
                                        —
                                    </div>
                                </div>
                            </div>
                            <div class="svg" v-if="header.length === 3" @click="editScores(item)">
                                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3.66945 19.2502C3.7437 19.2502 3.81795 19.241 3.89128 19.2227L7.55795 18.306C7.71928 18.2657 7.86687 18.1823 7.9842 18.065L19.2528 6.79638C19.5993 6.44988 19.79 5.98972 19.79 5.50022C19.79 5.01072 19.5993 4.55055 19.2528 4.20405L17.799 2.75022C17.106 2.05722 15.8996 2.05722 15.2066 2.75022L3.93803 14.0188C3.82076 14.1362 3.73745 14.2832 3.69695 14.4441L2.78028 18.1108C2.74642 18.246 2.74382 18.3871 2.77268 18.5234C2.80153 18.6597 2.86109 18.7876 2.94681 18.8975C3.03253 19.0073 3.14217 19.0962 3.26739 19.1573C3.39261 19.2184 3.53011 19.2502 3.66945 19.2502ZM16.5028 4.04639L17.9566 5.50022L16.5028 6.95405L15.049 5.50022L16.5028 4.04639ZM5.41387 15.1353L13.7528 6.79638L15.2066 8.25022L6.86678 16.5891L4.92895 17.0731L5.41387 15.1353Z" fill="#C0CADC"/>
                                </svg>
                            </div>
                            <div class="svg" v-if="header.length === 3" @click="removeScore(item, i)">
                                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M13.75 1.83301H8.25C7.23892 1.83301 6.41667 2.65526 6.41667 3.66634V5.49967H2.75V7.33301H4.58333V18.333C4.58333 19.3441 5.40558 20.1663 6.41667 20.1663H15.5833C16.5944 20.1663 17.4167 19.3441 17.4167 18.333V7.33301H19.25V5.49967H15.5833V3.66634C15.5833 2.65526 14.7611 1.83301 13.75 1.83301ZM8.25 3.66634H13.75V5.49967H8.25V3.66634ZM15.5833 18.333H6.41667V7.33301H15.5833V18.333Z" fill="#C0CADC"/>
                                </svg>
                            </div>
                        </div>
                    </div>
                    
                    <div class="footer">
                        <PaginationComponent
                                            :countAllItems="change_surcharge.length"
                                            :activePage="pagination.activePage"
                                            @updateCountItemsOnPage="updateCountItemsOnPage"
                                            @updatePage="updatePage"
                        >
                        </PaginationComponent>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import PaginationComponent from '../../DefaultComponents/PaginationComponent.vue';
    import { send } from '../../fetchData';

    export default {
        props: {
            header:{
                type: Array,
                default: () => {
                    return []
                }
            },
            header1:{
                type: Array,
                default: () => {
                    return []
                }
            },
            arr:{
                type: Array,
                default: () => {
                    return []
                }
            },
            arr1:{
                type: Array,
                default: () => {
                    return []
                }
            },
            title:{
                type: String,
                default: ''
            },
            stat_type:{
                type: Number,
                default: 0
            },
            studentId:{
                type: Number,
                default: 0
            },
            reasons:{
                type: Array,
                default: () => {
                    return []
                }
            }
        },
        name: 'static',
        data(){
            return {
                pagination:{
                  activePage: 1,
                  countItemsOnPage: 10,
                },
                pagination1:{
                  activePage: 1,
                  countItemsOnPage: 10,
                },
                showModule: false,
                title_header:[
                    {
                        id:0,
                        text: 'Оплаты',
                        check: true
                    }, 
                    {
                        id:1,
                        text: 'Изменение доплат',
                        check: false
                    }, 
                ],
                typeTitle: 0 ,
                typeStudent:[
                    {
                        id:0,
                        text:'Оплаты',
                    },
                    {
                        id:1,
                        text:'Изменение доплат',
                    },
                ],
                typeStudentId:0,
                change_surcharge:[]
            }
        },
        methods: {
            updateCountItemsOnPage(number) {
                this.pagination.countItemsOnPage = number;
            },
            updatePage(number) {
                this.pagination.activePage = number;
            },
            closeStatistic(){
                this.typeStudentId = 0
                this.$emit("close")
            },
            removeScore(item, i){
                let data = {
                    module:'md_remove_rating',
                    id: item.id
                }
                send
                    .post("marathon.php", data)
                    .then((response) =>{
                        console.log("Успех")
                        this.arr.splice(i, 1)
                    })
                    .catch((error) =>{
                        console.log("error")
                    })
            },
            editScores(item){
               this.$emit("editScore", item) 
            },
            selectTitle(title){
                this.title_header.forEach((tit, i) =>{
                    if(title.id === i){
                        title.check = true
                    }else if(title.id !== i){ 
                        tit.check = false
                    }
                })
                this.typeTitle = title.id
            },
            selectStudentFuncHeader(item){
                this.typeStudentId = item.id
                if(this.typeStudentId === 1){
                    let data = {
                        module: 'md_get_change_info',
                        id: this.studentId
                    }
                    send
                        .post("essay_trial_race.php", data)
                        .then((response) => {
                            console.log(response)
                             this.change_surcharge = []
                            response.pays.forEach((item, i) =>{
                                this.change_surcharge.push({
                                    id: item.id,
                                    name: this.getReasons(item.reason_id),
                                    manager: item.manager_name,
                                    time_str: item.time_str,
                                    new_amount: item.new_sum !== null ? item.new_sum : '0',
                                    change_amount: item.amount,
                                    comment: item.comment,
                                    showModule: false
                                })
                            })
                        })
                        .catch((error) => {
                            console.log(error.response.data)
                        })
                    
                }
            },
            getReasons(id){
                let text = ''
                console.log(id)
                this.reasons.forEach((item, i) =>{
                    if(item.id === id){
                        text = item.text
                    }
                })
                return text
            }
        },
        computed:{

            arrList(){
                let startElem = (this.pagination.activePage - 1) * this.pagination.countItemsOnPage;
                let endElem = startElem + this.pagination.countItemsOnPage;
                return this.change_surcharge.slice(startElem, endElem);
            },
            arrList1(){
                let startElem = (this.pagination1.activePage - 1) * this.pagination1.countItemsOnPage;
                let endElem = startElem + this.pagination1.countItemsOnPage;
                return this.arr1.slice(startElem, endElem);
            }
        },
        directives: {
            clickOutside: {
                bind(el, binding) {
                el.addEventListener('click', e => e.stopPropagation());
                document.body.addEventListener('click', binding.value);
                },
                unbind(el, binding) {
                document.body.removeEventListener('click', binding.value);
                }
            },
        },
        components: {
            PaginationComponent
        }
    }
</script>

<style lang="scss" scoped>
@import "../../../styles_fonts.scss";

    $font_Geometria: Geometria, 'Geometria';

    $color_background: #F6F6FB;
    $color_Gray_1: #C5C5C9;
    $color_Gray_2: #ABABB2;
    $color_Gray_3: #EBEBEB;
    $color_Gray_4:  #F9F9F9;
    $color_Gray_5: #8D909F;
    $color_black: #333333;
    $color_purple: #8C71FE;
    $color_purple_1: #7B61EB;
    $color_purple_2: #6F57D6;
    $color_purple2: #F2F1FF;
    $color_purple3: #E2E2F6;
    $color_purple6: #B1A1F2;
    $color_red: #FF6597;
    $color_white: #FFFFFF;
    $color_cyan: #C0CADC;
    $color_cyan2: #AEBCD6;
    $color_cyan3: #D1DBED;
    $color_green: #89ce54;


.fade-enter-active, .fade-leave-active {
    transition: opacity ease .5s;
}
.fade-enter, .fade-leave-to {
    opacity: 0;
}
.statistics{
    position: fixed;
    top: 0;
    left: 0;
    min-height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.39);
    display: flex;
    border: 0;
    align-items: center;
    justify-content: center;
    z-index: 100;
    font-family: $font_Geometria;
}
 .setting_groups_student_header{
     margin-bottom: 24px;
                .wallet_main_header_left{
                    display: flex;
                    width: 255px;
                    justify-content: space-between;
                }
                .select_student{
                    font-family: $font_Geometria;
                    font-style: normal;
                    font-weight: bold;
                    font-size: 15px;
                    line-height: 140%;
                    text-transform: uppercase;
                    color: $color_cyan;
                    padding-bottom: 2px;
                    border-bottom:2px solid $color_purple;
                    border-color: transparent;
                    transition: 0.5s;
                    cursor: pointer;

                }
                .select_student_active{
                    font-family: $font_Geometria;
                    font-style: normal;
                    font-weight: bold;
                    font-size: 15px;
                    line-height: 140%;
                    padding-bottom: 2px;
                    text-transform: uppercase;
                    color: $color_black;
                    cursor: pointer;
                    
                    border-bottom:2px solid $color_purple;
                }
                
                .select_student:hover{
                    color: $color_black;
                }
                
            }
.statistics_block{
    width: 58.5%;
    border: 0px solid rgba(0, 0, 0, 0.08);
    box-sizing: border-box;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25), 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 12px;
}
.statistics_header{
    padding: 24px 40px 22px 40px;
    background: $color_purple;
    border-radius: 12px 12px 0px 0px;
    display: flex;
    align-items:center;
    justify-content: space-between;

}
.title{
    font-family: $font_Geometria;
    font-style: normal;
    font-weight: bold;
    font-size: 22px;
    line-height: 120%;
    color: #FFFFFF;
}
.svg{
    cursor: pointer;
    display: flex;
    align-items: flex-end;
    
    .svg_block{
        display: flex;
        align-items: flex-end;
        svg path{
            transition: all 0.5s;
        }
        .svg_text{
            font-family: $font_Geometria;
            font-style: normal;
            font-weight: 500;
            font-size: 15px;
            line-height: 19px;
            display: flex;
            align-items: center;
            text-align: center;
            color: #AEBCD6;
        }
        .svg_block_active{
            position:relative;

            .svg_block_active_svg{
                display: flex;
                align-items: flex-end;
            }
            .svg_module{
                cursor:default;
                position: absolute;
                right:0;
                top:0;
                background: $color_white;
                border: 1px solid rgba(0, 0, 0, 0.08);
                box-sizing: border-box;
                border-radius: 8px;
                padding: 14px;
                font-family: $font_Geometria;
                font-style: normal;
                font-weight: normal;
                font-size: 16px;
                line-height: 140%;
                color: $color_black;

            }
        }
        
    }
    svg path{
        transition: all 0.5s;
    }
}
.svg{
    .svg_block{
        .svg_block_active:hover{
            .svg_block_active_svg{
                svg path{
                    transition: all 0.5s;
                }
            }
           
        }
        
    }
    svg path{
        transition: all 0.5s;
    }
}
.svg:hover{
    .svg_block{
        svg path{
            fill:$color_purple;
        }
    }
    svg path{
        //fill:$color_purple;
    }
}
.statistics_main_info{
    padding: 40px;
    background: #FFFFFF;
    border-radius: 0px 0px 12px 12px;
    max-height: 700px;
    overflow-y:scroll;
}

.statistics_main_info_block_all{
    padding-right: 10px;
}
.statistics_main_info::-webkit-scrollbar{
    -webkit-appearance: none;
    width: 4px;
    padding-right: 6px;
}
.statistics_main_info::-webkit-scrollbar-thumb{
    border-radius: 3px;
    background-color: $color_cyan;
    padding-right: 6px;
}
.statistics_main_info_header{
    display:flex;
    align-items:center;
    margin-bottom: 24px;
}
.statistics_main_info_header_text{
    cursor: pointer;
    font-family: $font_Geometria;
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    line-height: 140%;
    text-transform: uppercase;
    color: $color_cyan;
    margin-right: 24px;
    border-bottom: transparent;
}
.statistics_main_info_header_text{
    cursor: pointer;
    font-family: $font_Geometria;
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    line-height: 140%;
    text-transform: uppercase;
    color: $color_cyan;
    margin-right: 24px;
    border-bottom: 2px solid #8C71FE;
    border-color: transparent;
    transition: all 0.5s;
}
.statistics_main_info_header_text:hover{
    color: $color_black;
    border-bottom: 2px solid #8C71FE;
}
.statistics_main_info_header_text_active{
    cursor: pointer;
    font-family: $font_Geometria;
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    line-height: 140%;
    text-transform: uppercase;
    color: $color_black;
    margin-right: 24px;
    border-bottom: 2px solid #8C71FE;
    transition: all 0.5s;
}
.statistics_main_info_block{
    border: 1px solid #E2E2F6;
    box-sizing: border-box;
    border-radius: 8px;
}

.statistics_main_info_block_header{
    display: grid;
    grid-template-columns: 3fr 2.25fr 1.75fr 1.13fr 1.59fr;
    padding: 14px 0 12px 20px;
    background: $color_background;
    border-radius: 8px 8px 0px 0px;
    font-family: $font_Geometria;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;    
    color: $color_cyan;
}
.statistics_main_info_block_list{
    display: grid;
    grid-template-columns: 3fr 2.25fr 1.75fr 1.13fr 1.13fr 0.46fr;
    padding: 25px 0 24px 28px;
    border-bottom: 1px solid #E2E2F6;
    font-family: $font_Geometria;
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 19px;
    color: #333333;
}

.statistics_main_info_block_header_change_payment{
    display: grid;
    grid-template-columns: 3.01fr 2.25fr 1.75fr 1.13fr 1.59fr;
    padding: 14px 0 12px 20px;
    background: $color_background;
    border-radius: 8px 8px 0px 0px;
    font-family: $font_Geometria;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;    
    color: $color_cyan;
}
.statistics_main_info_block_header_change_payment_lengh_3{
    display: grid;
    grid-template-columns: 3.84fr 1.84fr 1.43fr;
    padding: 14px 0 12px 20px;
    background: $color_background;
    border-radius: 8px 8px 0px 0px;
    font-family: $font_Geometria;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;    
    color: $color_cyan;
}
.statistics_main_info_block_change_payment{
    display: grid;
    grid-template-columns: 3.01fr 2.25fr 1.75fr 1.13fr 1.135fr 0.455fr;
    padding: 25px 0 24px 28px;
    border-bottom: 1px solid #E2E2F6;
    font-family: $font_Geometria;
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 19px;
    color: #333333;
}
.statistics_main_info_block_change_payment_lengh_3{
    display: grid;
    grid-template-columns: 3.84fr 1.84fr 0.975fr 0.455fr;
    padding: 25px 0 24px 28px;
    border-bottom: 1px solid #E2E2F6;
    font-family: $font_Geometria;
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 19px;
    color: #333333;
}
.sourse{
    width: 86.5%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis; 
}
.month_block_none{
    display: none;
}
.discount_block_none{
    display: none;
}
.amount{
    color: $color_green;
}
.change_minus{
     color: $color_red;
}
.change{
     color: $color_green;
}
.footer{
    margin-top: 16px;
    display: flex;
    align-items:flex-end;
}
@media screen and (max-height: 850px) {
    .statistics_main_info{
        padding: 40px;
        background: #FFFFFF;
        border-radius: 0px 0px 12px 12px;
        max-height: 500px;
        overflow-y:scroll;
    }
}
@media screen and (max-height: 630px) {
    .statistics_main_info{
        padding: 40px;
        background: #FFFFFF;
        border-radius: 0px 0px 12px 12px;
        max-height: 450px;
        overflow-y:scroll;
    }
}
</style>